import React, { memo } from "react";
import PropTypes from "prop-types";
import "./CartItem.scss";
import useLoadDBImage from "../../hooks/useLoadDBImage.js";
import ProductPrice from "../product/ProductPrice.jsx";

const CartItemSimplified = memo(({ item }) => {
  const imageUrl = useLoadDBImage("onProductImages", null, item.id, item.imageId);

  return (
    <div className="cart-item-simplified flex flex-col gap-3 mb-3">

      <div className="flex gap-3 justify-between ">
        <div className="flex">
          {imageUrl &&
            <div className="relative">
              <div className="cart-item-image w-20 h-20 bg-secondary-light rounded-10 overflow-hidden">
                <img src={imageUrl} alt="Customized Product" className="w-full" />
              </div>
              <div className="cart-count">{item.quantity}</div>
            </div>
          }
          <div className="pl-4">
            {item.subscription && <span className="text-[10px] px-2 py-1 bg-secondary text-white rounded-20">SUBSCRIPTION</span>}
            <p className="text-mid mb-0">{item.name}</p>
            <p className="text-sm mb-0 capitalize">{item.tag}</p>
            {item.petName &&
              <p className="text-sm mb-2">Name: {item.petName}</p>
            }
          </div>
        </div>

        <ProductPrice price={item.price * item.quantity} isSubscribed={item.subscription} className="flex flex-col-reverse justify-end items-end" />

      </div>
    </div>
  );
});

CartItemSimplified.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    tag: PropTypes.string,
    petType: PropTypes.string,
    petName: PropTypes.string,
    price: PropTypes.number.isRequired,
    quantity: PropTypes.number.isRequired,
  }).isRequired,
  updateQuantity: PropTypes.func,
  removeItem: PropTypes.func,
};

export default CartItemSimplified;
